/**
 * @desc toggle switch directive; round switch with background-color change
 * @example <twp-toggle-switch active="" toggle=""></twp-toggle-switch>
 */

import template from './twpToggleSwitch.html';

function directive() {
  return {
    template,
    restrict: 'E',
    replace: true,
    scope: {
      active: '=',
      toggle: '='
    }
  };
}

export default function (ngModule) {
  ngModule.directive('twpToggleSwitch', directive);
}
